import React, { useState, useEffect, useContext } from "react";
import { ContextAuth } from "../../../contexts/ContextAuth";
import { getCurrentDate } from "../../../configs/helpers";
import { NewOrderPurchaseOperationForm } from "../fragments.buys/NewOrderPurchaseOperationForm";
import { NewOrderPurchaseOperationDetailForm } from "../fragments.buys/NewOrderPurchaseOperationDetailForm";
import { NewOrderPurchaseOperationDetailList } from "../fragments.buys/NewOrderPurchaseOperationDetailList";
import {
    initialOrderState,
    initialOptionState,
} from "../../../configs/OrderPurchaseStates";

export function NewOrderPurchasePage() {
    const { auth } = useContext(ContextAuth);
    const [order, setOrder] = useState(initialOrderState);
    const [selectedOption, setSelectedOption] = useState(initialOptionState);

    useEffect(() => {
        const fechaActual = getCurrentDate("-");
        const fechaObjeto = new Date(fechaActual);
        fechaObjeto.setFullYear(fechaObjeto.getFullYear() + 1);
        const nuevaFecha = fechaObjeto.toISOString().split("T")[0];
        setSelectedOption({
            ...selectedOption,
            expireDate: nuevaFecha,
        });

        setOrder({
            ...order,
            userID: auth.data.user_id,
        });
    }, []);

    return (
        <>
            <section className="mb-6">
                <div className="max-w-full px-4">
                    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                        <h1 className="text-2xl font-bold text-gray-900 dark:text-white tracking-tight">
                            Registrar Pedido de Compra
                        </h1>
                    </div>
                </div>
            </section>
            <section>
                <div className="max-w-full px-4">
                    <NewOrderPurchaseOperationForm
                        order={order}
                        setOrder={setOrder}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                    />
                    <NewOrderPurchaseOperationDetailForm
                        order={order}
                        setOrder={setOrder}
                        selectedOption={selectedOption}
                        setSelectedOption={setSelectedOption}
                        initialOptionState={initialOptionState}
                    />
                    <NewOrderPurchaseOperationDetailList
                        order={order}
                        setOrder={setOrder}
                        initialOrderState={initialOrderState}
                    />
                </div>
            </section>
        </>
    );
}
